
import { IState } from '@app/store';
import StoreUtil from '@app/store/StoreUtil';
import {
    getBalanceWithBonus,
    isIdCardVerificationPending,
} from '@core/models/user/UserDataService';
import { NotificationType } from '@models/user/enums';
import UserNotification from '@models/user/notifications/UserNotification';
import { getNotifications } from '@accountFederation/notifications';
import { NotificationTab } from '@modules/userProfile/notifications/types';
import { createSimpleMutator } from '@superbet-group/web.lib.vue-utilities';

export const ADD_NOTIFICATION = 'ADD_NOTIFICATION';
export const REMOVE_NOTIFICATION = 'REMOVE_NOTIFICATION';
export const CLEAR_NOTIFICATIONS = 'CLEAR_NOTIFICATIONS';
export const SET_ACTIVE_NOTIFICATION_TAB = 'SET_ACTIVE_NOTIFICATION_TAB';

export interface INotificationsState {
    notifications: UserNotification[];
    notificationActiveTab: NotificationTab;
}

function defaultState(): INotificationsState {
    return {
        notifications: [],
        notificationActiveTab: NotificationTab.Messages,
    };
}

const store = {
    namespaced: true,

    state: defaultState(),

    mutations: {
        [ADD_NOTIFICATION]: StoreUtil.createPushToListMutator('notifications'),
        [REMOVE_NOTIFICATION](state: INotificationsState, type: NotificationType) {
            const index = state.notifications.findIndex((n) => n.type === type);

            if (index === -1) {
                return;
            }

            state.notifications.splice(index, 1);
        },
        [CLEAR_NOTIFICATIONS]: StoreUtil.createClearListMutator('notifications'),
        [SET_ACTIVE_NOTIFICATION_TAB]: createSimpleMutator<INotificationsState, 'notificationActiveTab'>('notificationActiveTab'),
    },

    getters: {
        notifications: (state: INotificationsState, getters: any, rootState: IState, rootGetters: any) => {
            const user = rootGetters['data/authentication/user'];

            if (!user) {
                return [];
            }

            const notifications = getNotifications(user);
            const balance = getBalanceWithBonus(user);

            if (balance && balance < 2) {
                notifications.push({
                    title: 'user balance to low',
                    type: NotificationType.lowBalance,
                });
            }

            const isIdCardPendingInNotifications = state.notifications
                .find((n: UserNotification) => n.type === NotificationType.idCardVerificationPending);
            if (isIdCardVerificationPending(user) && !isIdCardPendingInNotifications) {
                notifications.push({
                    title: 'Know your user pending',
                    type: NotificationType.idCardVerificationPending,
                });
            }

            return [
                ...notifications,
                ...state.notifications,
            ];
        },
    },

    actions: {
        addNotification: StoreUtil.createSimpleMutatorAction(ADD_NOTIFICATION),
        removeNotification: StoreUtil.createSimpleMutatorAction(REMOVE_NOTIFICATION),
        clearNotifications: StoreUtil.createSimpleMutatorAction(CLEAR_NOTIFICATIONS),
        setActiveNotificationTab: StoreUtil.createSimpleMutatorAction(SET_ACTIVE_NOTIFICATION_TAB),
    },
};

export type NotificationsStore = typeof store;

export default store;
